import { render, staticRenderFns } from "./TrustedShops.vue?vue&type=template&id=413f19cf&"
import script from "./TrustedShops.vue?vue&type=script&lang=js&"
export * from "./TrustedShops.vue?vue&type=script&lang=js&"
import style0 from "./TrustedShops.vue?vue&type=style&index=0&id=413f19cf&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports